<template>
    <div class="category-pill">
        <span>
            <slot name="category-name" />
        </span>
    </div>
</template>

<script>
export default {
    name: "CategoryPill"
}
</script>

<style lang="scss">
.category-pill {
    color: white;
    text-transform: uppercase;
    background-color: rgba(255, 255, 255, .2);
    font-size: 15px;
    font-weight: 500;
    width: fit-content;
    border-radius: 6px;
    padding: 7px 10px;
    display: table;

    @media (max-width: $md) {
        font-size: 11px;
    }
}
</style>
